module.exports = __webpack_public_path__ + "fc0f2664d8aad809eefcb66fae1112e9.fbx";